import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createContext } from 'react';

import styles from './Select.module.scss';

interface SelectProps {
  onSelect: (value: string) => void;
  defaultValue?: string;
  disabled?: boolean;
  value: string;
  size?: 'regular' | 'small';
  errorMessage?: string;
  showError?: boolean;
}

interface OptionProps {
  value?: string;
  disabled?: boolean;
  selected?: boolean;
}

interface SelectContextValues {
  selectedValue: string;
}

// Without this it gets a bit annoying to supply a default disabled option that is initially selected.
// You need to set the default value to "" which is wierd. Also this may be better from an ARIA perspective
const SelectContext = createContext<SelectContextValues>({
  selectedValue: '',
});

const Option: React.FC<React.PropsWithChildren<OptionProps>> = ({
  value,
  disabled = false,
  selected = false,
  children: text,
}) => {
  return (
    <option
      className={styles['option']}
      value={disabled ? '' : value}
      disabled={disabled}
      selected={selected}
    >
      {text}
    </option>
  );
};

const Select: React.FC<React.PropsWithChildren<SelectProps>> = ({
  value,
  children,
  onSelect,
  defaultValue = '',
  disabled = false,
  size = 'regular',
  showError = false,
  errorMessage,
}) => {
  return (
    <SelectContext.Provider value={{ selectedValue: value || defaultValue }}>
      <div className={styles['select']} data-size={size}>
        <select
          value={value || defaultValue}
          onChange={(e) => onSelect(e.target.value)}
          disabled={disabled}
          required
          data-error={showError}
        >
          {children}
        </select>
        <div className={styles['icon-container']}>
          <FontAwesomeIcon icon={faAngleDown} />
        </div>
        {showError && <span className={styles['error-text']}>{errorMessage}</span>}
      </div>
    </SelectContext.Provider>
  );
};

export default Select;
export { Select, Option };
